// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* File: src/styles/Leaderboard.css */

.leaderboard {
    width: 100%;
    max-width: 900px;
    margin: 0 auto;
    padding: 20px;
    font-family: 'Inter', sans-serif;
}

.page-header {
    margin-bottom: 40px;
    text-align: center;
}

.page-header h1 {
    font-size: 2.2rem;
    font-weight: 700;
    margin-bottom: 10px;
    background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    letter-spacing: 0.5px;
}

.page-header p {
    color: var(--text-secondary);
    font-size: 1rem;
    max-width: 600px;
    margin: 0 auto;
}

/* Loading animation */
.loading-container {
    text-align: center;
    padding: 60px 0;
}

.loading-spinner {
    display: inline-block;
    width: 50px;
    height: 50px;
    border: 4px solid rgba(144, 238, 144, 0.1);
    border-left-color: var(--primary-color);
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 20px;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}

.loading-container p {
    color: var(--text-secondary);
    font-size: 0.9rem;
}

/* Leaderboard container */
.leaderboard-container {
    background: var(--background-light);
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
    overflow: hidden;
    position: relative;
    border: 1px solid var(--border-color);
}

.leaderboard-container::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));
    z-index: 1;
}

/* Header */
.leaderboard-header {
    display: grid;
    grid-template-columns: 80px 1fr 180px;
    padding: 16px 20px;
    background-color: rgba(0, 0, 0, 0.2);
    font-weight: 500;
    color: var(--text-secondary);
    text-transform: uppercase;
    font-size: 0.75rem;
    letter-spacing: 1px;
    border-bottom: 1px solid var(--border-color);
}

/* Row styles */
.leaderboard-row {
    display: grid;
    grid-template-columns: 80px 1fr 180px;
    padding: 14px 20px;
    border-bottom: 1px solid var(--border-color);
    align-items: center;
    transition: all 0.3s ease;
    transform: translateY(20px);
    opacity: 0;
}

.leaderboard-container.animate .leaderboard-row {
    transform: translateY(0);
    opacity: 1;
}

.leaderboard-row:hover {
    background-color: rgba(255, 255, 255, 0.03);
}

.leaderboard-row:last-child {
    border-bottom: none;
}

/* Rank badge */
.rank-badge {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    font-weight: 600;
    color: var(--text-secondary);
}

/* Trophy styles */
.trophy {
    font-size: 1.6rem;
    display: block;
}

.trophy.gold {
    text-shadow: 0 0 10px rgba(255, 215, 0, 0.4);
}

.trophy.silver {
    text-shadow: 0 0 8px rgba(192, 192, 192, 0.4);
}

.trophy.bronze {
    text-shadow: 0 0 8px rgba(205, 127, 50, 0.4);
}

/* User profile section */
.user-profile {
    display: flex;
    align-items: center;
    gap: 15px;
}

.user-avatar {
    width: 46px;
    height: 46px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--background-dark);
    font-weight: 600;
    font-size: 1rem;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.user-profile:hover .user-avatar {
    transform: scale(1.08);
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.4);
}

.user-info {
    display: flex;
    flex-direction: column;
    flex: 1 1;
}

.user-info h3 {
    margin: 0 0 8px 0;
    font-size: 1rem;
    font-weight: 500;
    color: var(--text-primary);
}

/* Progress bar */
.progress-container {
    width: 100%;
    height: 4px;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 2px;
    overflow: hidden;
}

.progress-bar {
    height: 100%;
    background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));
    border-radius: 2px;
    transition: width 1s ease-out;
    box-shadow: 0 0 8px rgba(144, 238, 144, 0.4);
}

/* Stats section */
.user-stats {
    display: flex;
    justify-content: space-between;
    gap: 10px;
}

.stat-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 8px;
}

.stat-value {
    font-weight: 600;
    font-size: 1rem;
    color: var(--text-primary);
}

.stat-item.points .stat-value {
    font-size: 1.2rem;
    color: var(--primary-color);
}

.stat-label {
    font-size: 0.7rem;
    color: var(--text-secondary);
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

/* Current user highlighting */
.current-user {
    background-color: rgba(144, 238, 144, 0.05);
    position: relative;
}

.current-user::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    background: linear-gradient(to bottom, var(--primary-color), var(--secondary-color));
    border-radius: 0 1px 1px 0;
}

.current-user:hover {
    background-color: rgba(144, 238, 144, 0.08);
}

/* Responsive design */
@media (max-width: 768px) {
    .leaderboard-header {
        grid-template-columns: 60px 1fr auto;
    }
    
    .leaderboard-row {
        grid-template-columns: 60px 1fr auto;
        padding: 12px 10px;
    }
    
    .user-avatar {
        width: 38px;
        height: 38px;
        font-size: 0.9rem;
    }
    
    .user-stats {
        flex-direction: column;
        gap: 4px;
    }
    
    .stat-item {
        flex-direction: row;
        gap: 4px;
        justify-content: flex-end;
        align-items: baseline;
    }
    
    .stat-label {
        font-size: 0.65rem;
    }
    
    .stat-value {
        font-size: 0.9rem;
    }
    
    .page-header h1 {
        font-size: 1.8rem;
    }
    
    .page-header p {
        font-size: 0.9rem;
    }
}

/* Animations */
@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.leaderboard-row {
    animation: fadeInUp 0.5s ease-out forwards;
    animation-play-state: paused;
}

.leaderboard-container.animate .leaderboard-row {
    animation-play-state: running;
}

/* Top ranks glow effects */
.leaderboard-row:nth-child(2) {
    position: relative;
    overflow: hidden;
}

.leaderboard-row:nth-child(2)::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, var(--primary-color), transparent);
    opacity: 0.5;
}

/* Cyber security themed elements */
.rank-badge::before {
    content: '';
    position: absolute;
    width: 30px;
    height: 30px;
    background-color: rgba(144, 238, 144, 0.05);
    border-radius: 50%;
    z-index: -1;
}`, "",{"version":3,"sources":["webpack://./src/styles/Leaderboard.css"],"names":[],"mappings":"AAAA,qCAAqC;;AAGrC;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gFAAgF;IAChF,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA,sBAAsB;AACtB;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,uCAAuC;IACvC,kBAAkB;IAClB,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA,0BAA0B;AAC1B;IACI,mCAAmC;IACnC,kBAAkB;IAClB,yCAAyC;IACzC,gBAAgB;IAChB,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,gFAAgF;IAChF,UAAU;AACd;;AAEA,WAAW;AACX;IACI,aAAa;IACb,qCAAqC;IACrC,kBAAkB;IAClB,oCAAoC;IACpC,gBAAgB;IAChB,4BAA4B;IAC5B,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA,eAAe;AACf;IACI,aAAa;IACb,qCAAqC;IACrC,kBAAkB;IAClB,4CAA4C;IAC5C,mBAAmB;IACnB,yBAAyB;IACzB,2BAA2B;IAC3B,UAAU;AACd;;AAEA;IACI,wBAAwB;IACxB,UAAU;AACd;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,mBAAmB;AACvB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA,kBAAkB;AAClB;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,4CAA4C;AAChD;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,yCAAyC;IACzC,qDAAqD;AACzD;;AAEA;IACI,sBAAsB;IACtB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA,iBAAiB;AACjB;IACI,WAAW;IACX,WAAW;IACX,0CAA0C;IAC1C,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gFAAgF;IAChF,kBAAkB;IAClB,6BAA6B;IAC7B,4CAA4C;AAChD;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,8BAA8B;AAC9B;IACI,2CAA2C;IAC3C,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,SAAS;IACT,UAAU;IACV,oFAAoF;IACpF,0BAA0B;AAC9B;;AAEA;IACI,2CAA2C;AAC/C;;AAEA,sBAAsB;AACtB;IACI;QACI,oCAAoC;IACxC;;IAEA;QACI,oCAAoC;QACpC,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;QACI,mBAAmB;QACnB,QAAQ;QACR,yBAAyB;QACzB,qBAAqB;IACzB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA,eAAe;AACf;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,0CAA0C;IAC1C,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA,2BAA2B;AAC3B;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,kFAAkF;IAClF,YAAY;AAChB;;AAEA,mCAAmC;AACnC;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,2CAA2C;IAC3C,kBAAkB;IAClB,WAAW;AACf","sourcesContent":["/* File: src/styles/Leaderboard.css */\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');\n\n.leaderboard {\n    width: 100%;\n    max-width: 900px;\n    margin: 0 auto;\n    padding: 20px;\n    font-family: 'Inter', sans-serif;\n}\n\n.page-header {\n    margin-bottom: 40px;\n    text-align: center;\n}\n\n.page-header h1 {\n    font-size: 2.2rem;\n    font-weight: 700;\n    margin-bottom: 10px;\n    background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));\n    -webkit-background-clip: text;\n    background-clip: text;\n    color: transparent;\n    letter-spacing: 0.5px;\n}\n\n.page-header p {\n    color: var(--text-secondary);\n    font-size: 1rem;\n    max-width: 600px;\n    margin: 0 auto;\n}\n\n/* Loading animation */\n.loading-container {\n    text-align: center;\n    padding: 60px 0;\n}\n\n.loading-spinner {\n    display: inline-block;\n    width: 50px;\n    height: 50px;\n    border: 4px solid rgba(144, 238, 144, 0.1);\n    border-left-color: var(--primary-color);\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n    margin-bottom: 20px;\n}\n\n@keyframes spin {\n    to { transform: rotate(360deg); }\n}\n\n.loading-container p {\n    color: var(--text-secondary);\n    font-size: 0.9rem;\n}\n\n/* Leaderboard container */\n.leaderboard-container {\n    background: var(--background-light);\n    border-radius: 8px;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);\n    overflow: hidden;\n    position: relative;\n    border: 1px solid var(--border-color);\n}\n\n.leaderboard-container::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 3px;\n    background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));\n    z-index: 1;\n}\n\n/* Header */\n.leaderboard-header {\n    display: grid;\n    grid-template-columns: 80px 1fr 180px;\n    padding: 16px 20px;\n    background-color: rgba(0, 0, 0, 0.2);\n    font-weight: 500;\n    color: var(--text-secondary);\n    text-transform: uppercase;\n    font-size: 0.75rem;\n    letter-spacing: 1px;\n    border-bottom: 1px solid var(--border-color);\n}\n\n/* Row styles */\n.leaderboard-row {\n    display: grid;\n    grid-template-columns: 80px 1fr 180px;\n    padding: 14px 20px;\n    border-bottom: 1px solid var(--border-color);\n    align-items: center;\n    transition: all 0.3s ease;\n    transform: translateY(20px);\n    opacity: 0;\n}\n\n.leaderboard-container.animate .leaderboard-row {\n    transform: translateY(0);\n    opacity: 1;\n}\n\n.leaderboard-row:hover {\n    background-color: rgba(255, 255, 255, 0.03);\n}\n\n.leaderboard-row:last-child {\n    border-bottom: none;\n}\n\n/* Rank badge */\n.rank-badge {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 1rem;\n    font-weight: 600;\n    color: var(--text-secondary);\n}\n\n/* Trophy styles */\n.trophy {\n    font-size: 1.6rem;\n    display: block;\n}\n\n.trophy.gold {\n    text-shadow: 0 0 10px rgba(255, 215, 0, 0.4);\n}\n\n.trophy.silver {\n    text-shadow: 0 0 8px rgba(192, 192, 192, 0.4);\n}\n\n.trophy.bronze {\n    text-shadow: 0 0 8px rgba(205, 127, 50, 0.4);\n}\n\n/* User profile section */\n.user-profile {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n}\n\n.user-avatar {\n    width: 46px;\n    height: 46px;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--background-dark);\n    font-weight: 600;\n    font-size: 1rem;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.user-profile:hover .user-avatar {\n    transform: scale(1.08);\n    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.4);\n}\n\n.user-info {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n}\n\n.user-info h3 {\n    margin: 0 0 8px 0;\n    font-size: 1rem;\n    font-weight: 500;\n    color: var(--text-primary);\n}\n\n/* Progress bar */\n.progress-container {\n    width: 100%;\n    height: 4px;\n    background-color: rgba(255, 255, 255, 0.1);\n    border-radius: 2px;\n    overflow: hidden;\n}\n\n.progress-bar {\n    height: 100%;\n    background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));\n    border-radius: 2px;\n    transition: width 1s ease-out;\n    box-shadow: 0 0 8px rgba(144, 238, 144, 0.4);\n}\n\n/* Stats section */\n.user-stats {\n    display: flex;\n    justify-content: space-between;\n    gap: 10px;\n}\n\n.stat-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 0 8px;\n}\n\n.stat-value {\n    font-weight: 600;\n    font-size: 1rem;\n    color: var(--text-primary);\n}\n\n.stat-item.points .stat-value {\n    font-size: 1.2rem;\n    color: var(--primary-color);\n}\n\n.stat-label {\n    font-size: 0.7rem;\n    color: var(--text-secondary);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n/* Current user highlighting */\n.current-user {\n    background-color: rgba(144, 238, 144, 0.05);\n    position: relative;\n}\n\n.current-user::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: 3px;\n    background: linear-gradient(to bottom, var(--primary-color), var(--secondary-color));\n    border-radius: 0 1px 1px 0;\n}\n\n.current-user:hover {\n    background-color: rgba(144, 238, 144, 0.08);\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n    .leaderboard-header {\n        grid-template-columns: 60px 1fr auto;\n    }\n    \n    .leaderboard-row {\n        grid-template-columns: 60px 1fr auto;\n        padding: 12px 10px;\n    }\n    \n    .user-avatar {\n        width: 38px;\n        height: 38px;\n        font-size: 0.9rem;\n    }\n    \n    .user-stats {\n        flex-direction: column;\n        gap: 4px;\n    }\n    \n    .stat-item {\n        flex-direction: row;\n        gap: 4px;\n        justify-content: flex-end;\n        align-items: baseline;\n    }\n    \n    .stat-label {\n        font-size: 0.65rem;\n    }\n    \n    .stat-value {\n        font-size: 0.9rem;\n    }\n    \n    .page-header h1 {\n        font-size: 1.8rem;\n    }\n    \n    .page-header p {\n        font-size: 0.9rem;\n    }\n}\n\n/* Animations */\n@keyframes fadeInUp {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.leaderboard-row {\n    animation: fadeInUp 0.5s ease-out forwards;\n    animation-play-state: paused;\n}\n\n.leaderboard-container.animate .leaderboard-row {\n    animation-play-state: running;\n}\n\n/* Top ranks glow effects */\n.leaderboard-row:nth-child(2) {\n    position: relative;\n    overflow: hidden;\n}\n\n.leaderboard-row:nth-child(2)::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 1px;\n    background: linear-gradient(90deg, transparent, var(--primary-color), transparent);\n    opacity: 0.5;\n}\n\n/* Cyber security themed elements */\n.rank-badge::before {\n    content: '';\n    position: absolute;\n    width: 30px;\n    height: 30px;\n    background-color: rgba(144, 238, 144, 0.05);\n    border-radius: 50%;\n    z-index: -1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
